import { createInertiaApp } from '@inertiajs/svelte'
import { mount } from 'svelte'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.svelte', { eager: false })
    const resolver = pages[`../pages/${name}.svelte`]
    if (!resolver) {
      console.error(`Missing Inertia page component: '${name}.svelte'`)
    }
    return resolver()
  },
  setup({ el, App, props }) {
    if (el) {
      mount(App, { target: el, props })
    } else {
      console.error('Missing root element. Inertia requires a <div id="app"> wrapper.')
    }
  },
})
